var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 171,
    viewBox: "0 0 10 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427319682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 31",
    d: "M5 4L5.00001 166",
    stroke: "#667085",
    strokeWidth: 0.5,
    strokeDasharray: "6 6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 427319679"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1212",
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#4037acd6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1211",
    cx: 5,
    cy: 5,
    r: 2.5,
    fill: "#4037acd6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 427319680"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1212_2",
    cx: 5,
    cy: 166,
    r: 5,
    fill: "#4037acd6",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1211_2",
    cx: 5,
    cy: 166,
    r: 2.5,
    fill: "#4037acd6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDetails);
export default __webpack_public_path__ + "static/media/flight-details.cdae6a7ab1c5770e815e4a03e77e0781.svg";
export { ForwardRef as ReactComponent };